var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('list-widget', {
    attrs: {
      "title": "결제사",
      "minWidth": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var attrs = _ref.attrs;
        return [_c('v-select', _vm._b({
          attrs: {
            "dense": "",
            "flat": "",
            "solo": "",
            "hide-details": ""
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.query['payment.openbank.pg'],
            callback: function callback($$v) {
              _vm.$set(_vm.query, 'payment.openbank.pg', $$v);
            },
            expression: "query['payment.openbank.pg']"
          }
        }, 'v-select', Object.assign({}, attrs, {
          items: _vm.items
        }), false))];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }